import { NUMBER } from "../../../constants/app-constants";
import { PICKUP_UNDER_PROGRESS } from "../../../constants/seller-diy-constants";
import { sendCustomGaEvents } from "../../../tracking";
import isObjectEmpty from "../../../utils/helpers/isObjectEmpty";
import { DSI_ELIGIBILITY_RESPONSES } from "../post-inspection-diy-header-v2/constant";
import { DIY_DOCUMENT_VERFIFICATION_STATES } from "../post-inspection-diy/constant";
import { isEkycDocVerified } from "../post-inspection-diy/selector";
import { GA_STEPS, LOAN_STEP, STEPS, STEP_NAMES, TAB_STATUS } from "./constant";

const BANK_ERROR_STATES = [
    DIY_DOCUMENT_VERFIFICATION_STATES.VERIFICATION_FAILED,
    DIY_DOCUMENT_VERFIFICATION_STATES.OCR_FAILED,
    DIY_DOCUMENT_VERFIFICATION_STATES.SYSTEM_FAILED,
    DIY_DOCUMENT_VERFIFICATION_STATES.BANK_FAILED
];

export const BANK_UNDER_VERIFICATION_STATES = [
    DIY_DOCUMENT_VERFIFICATION_STATES.PARTIALLY_MATCHED_CONFIRMED,
    DIY_DOCUMENT_VERFIFICATION_STATES.MISMATCH_CONFIRMED
];

const BANK_MISMATCH_ACTION_REQUIRED_STATES = [
    DIY_DOCUMENT_VERFIFICATION_STATES.MISMATCH,
    DIY_DOCUMENT_VERFIFICATION_STATES.PARTIALLY_MATCHED
];

// eslint-disable-next-line max-params
export const getBankStatus = (bankDetails = {}, isDeliveryApproved = false, showSelfBought, isMismatchAccepted) => {
    if (isDeliveryApproved) return TAB_STATUS.VERIFIED;

    if (isObjectEmpty(bankDetails)) return "";
    const {
        transactionStatus = "",
        verified: isBankVerified
    } = bankDetails || {};
    if (showSelfBought) {
        if (isMismatchAccepted) return TAB_STATUS.VERIFIED;
        if (isMismatchAccepted === false) return TAB_STATUS.FAILED;
    }
    if (isBankVerified) return TAB_STATUS.VERIFIED;
    if (BANK_ERROR_STATES.includes(transactionStatus)) return TAB_STATUS.FAILED;
    if (BANK_UNDER_VERIFICATION_STATES.includes(transactionStatus)) return TAB_STATUS.UNDER_VERIFICATION;
    if (BANK_MISMATCH_ACTION_REQUIRED_STATES.includes(transactionStatus)) return TAB_STATUS.ACTION_REQUIRED;
    return "";
};

// eslint-disable-next-line complexity
export const getDocsStatus = (postTokenDocuments, isDeliveryApproved = false) => {
    if (isDeliveryApproved) return TAB_STATUS.VERIFIED;

    const { total: totalDocumentCount,
        UPLOAD_PENDING: pendingDocumentCount = NUMBER.ZERO,
        VERIFICATION_PENDING: beingVerifiedDocumentCount,
        VERIFICATION_FAILED: verificationFailedDocumentCount = NUMBER.ZERO,
        REJECTED: rejectedDocumentCount = NUMBER.ZERO,
        APPROVED: approvedDocumentCount = NUMBER.ZERO,
        UPLOADED: uploadedDocumentCount = NUMBER.ZERO,
        documents
    } = postTokenDocuments || {};
    const { isAllOtherDocumentsApproved } = documents || {};

    if (isAllOtherDocumentsApproved) return TAB_STATUS.VERIFIED;
    if (totalDocumentCount === approvedDocumentCount) return TAB_STATUS.VERIFIED;
    if (verificationFailedDocumentCount > NUMBER.ZERO || rejectedDocumentCount > NUMBER.ZERO) return TAB_STATUS.ACTION_REQUIRED;
    if (beingVerifiedDocumentCount > NUMBER.ZERO) return TAB_STATUS.UNDER_VERIFICATION;
    if (approvedDocumentCount + uploadedDocumentCount) return TAB_STATUS.UNDER_VERIFICATION;
    if (pendingDocumentCount && pendingDocumentCount !== totalDocumentCount) return TAB_STATUS.PENDING;
    return "";
};

export const getLoanDocsStatus = (postTokenDocuments, isDeliveryApproved = false) => {
    if (isDeliveryApproved) return TAB_STATUS.VERIFIED;

    const {   total: totalDocumentCount,
        UPLOAD_PENDING: pendingDocumentCount = NUMBER.ZERO,
        VERIFICATION_FAILED: verificationFailedDocumentCount = NUMBER.ZERO,
        REJECTED: rejectedDocumentCount = NUMBER.ZERO,
        APPROVED: approvedDocumentCount = NUMBER.ZERO,
        UPLOADED: uploadedDocumentCount = NUMBER.ZERO,
        VERIFICATION_PENDING: underVerificationCount = NUMBER.ZERO
    } = postTokenDocuments || {};

    if (totalDocumentCount === approvedDocumentCount) return TAB_STATUS.VERIFIED;
    if (verificationFailedDocumentCount || rejectedDocumentCount) return TAB_STATUS.ACTION_REQUIRED;
    if (uploadedDocumentCount > NUMBER.ZERO || underVerificationCount > NUMBER.ZERO) return TAB_STATUS.UNDER_VERIFICATION;
    if (pendingDocumentCount && pendingDocumentCount !== totalDocumentCount) return TAB_STATUS.PENDING;
    return "";
};

export const getPickUpStatus = ({pickupStatus, isPriceAccepted = false, slotExpired = false, isDeliveryApproved = false}) => {
    if (isDeliveryApproved) return TAB_STATUS.PICKUP_SCHEDULED;
    if (!isPriceAccepted) return TAB_STATUS.SLOT_UNAVAILABLE;
    if (slotExpired) return TAB_STATUS.SLOT_EXPIRED;
    if (PICKUP_UNDER_PROGRESS.includes(pickupStatus)) return TAB_STATUS.PICKUP_SCHEDULED;
    return "";
};

export const isTokenEligible = (status) => {
    return [DSI_ELIGIBILITY_RESPONSES.TOKEN, DSI_ELIGIBILITY_RESPONSES.DSI_OR_TOKEN].includes(status);
};

export const bankAndEkycVerification = (postTokenDocs) => {
    const { bank: bankDetails, documents } = postTokenDocs || {};
    const bankIsVerified =  !isObjectEmpty(bankDetails);
    const ekycDocVerified = isEkycDocVerified(documents);
    return bankIsVerified && ekycDocVerified;
};

export const getDocumentationSteps = (hypo, isFranchise) => {
    if (isFranchise) {
        STEPS.splice(NUMBER.TWO, NUMBER.ONE);
    } else if (hypo && STEPS[NUMBER.ONE].name !== STEP_NAMES.LOAN) {
        STEPS.splice(NUMBER.ONE, NUMBER.ZERO, LOAN_STEP);
    }
    return STEPS;
};

export const callGaEventforStep = (step, apptID) => {
    if (GA_STEPS[step]) {
        sendCustomGaEvents({
            ...GA_STEPS[step],
            eventLabel: apptID
        });
    }
};

export const isBankVerificationCompleted = ({bankDetails, isDeliveryApproved, showSelfBought, isMismatchAccepted}) => {
    if (showSelfBought && isMismatchAccepted) return true;
    if (showSelfBought && isMismatchAccepted === false) return false;
    if (isDeliveryApproved) return true;
    const {
        transactionStatus = "",
        verified: isBankVerified
    } = bankDetails || {};
    const isBankPartiallyConfirmed = BANK_UNDER_VERIFICATION_STATES.includes(transactionStatus);
    return (isBankVerified || isBankPartiallyConfirmed);
};
